export default {
  title: {
    en: 'Oops... Something went wrong'
  },

  retry: {
    en: 'Please try again later.'
  }
};
